export const formatCpfNumber = (value) => {
  let formatted = value.replace(/\D/g, '');

  if (formatted.length > 3) {
    formatted = formatted.replace(/^(\d{3})(\d{0,3})(\d{0,3})(\d{0,2}).*/, (match, p1, p2, p3, p4) => {
      let result = p1;

      if (p2) result += `.${p2}`;
      if (p3) result += `.${p3}`;
      if (p4) result += `-${p4}`;

      return result;
    });

    formatted = formatted.slice(0, 14);
  }

  return formatted;
};

export const getOriginalCpf = (value = '') => value.replaceAll('.', '').replaceAll('-', '');
